import React, {FC} from 'react';
import styles from './errorText.module.scss';
import {P} from "../../../Text/Text";

/**
 * Error text component for custom form validation
 * */

type ErrorTextPropTypes = {
    text: string;
}

const ErrorText: FC<ErrorTextPropTypes> = ({text}) => {
    return text ? (
        <P className={styles.errorText}>{text}</P>
    ) : (<></>);
};

export default ErrorText;